import { baseAssets } from './assets'
import { lightThemeColors } from './colors'
import { defaultComponentStyles } from './componentStyles'
import { DEFAULT_THEME, Theme } from './theme'
import { defaultModeratFontFamilyMetadata, FontFamilyMetadata } from '../fontFamilyMetadata'
import { getProductTypeToMetadata, PRODUCT_TYPE, ProductBrand, ThemeMetadata } from '../productType'

/**
 * Resolve the theme bundle for a product type, preferring a brand override when the product
 * declares one for the given brand. Falls back to the product's default bundle when the brand
 * is absent or the product has no branded variants, so existing (brand-less) resolution is
 * unchanged.
 */
const resolveThemeBundle = (productType: PRODUCT_TYPE, brand: ProductBrand | undefined, forceNonAurora: boolean) => {
  const productBundle = getProductTypeToMetadata(forceNonAurora)[productType]
  const brandBundle = brand ? productBundle?.brand?.[brand] : undefined
  return brandBundle ?? productBundle
}

export const getProductTypeThemeMetadata = (
  theme: Theme.DARK | Theme.LIGHT = DEFAULT_THEME,
  productType: PRODUCT_TYPE = PRODUCT_TYPE.WFMH,
  forceNonAurora = false,
  brand?: ProductBrand,
): ThemeMetadata => {
  const themeMetadata = resolveThemeBundle(productType, brand, forceNonAurora)?.theme[theme]
  if (themeMetadata) {
    return themeMetadata
  }

  return { colorTokens: lightThemeColors, assets: baseAssets, componentStyles: defaultComponentStyles }
}

export const getProductTypeSupportedFontFamily = (
  productType: PRODUCT_TYPE = PRODUCT_TYPE.WFMH,
  forceNonAurora = false,
  brand?: ProductBrand,
): FontFamilyMetadata =>
  resolveThemeBundle(productType, brand, forceNonAurora)?.fontFamilyMetadata ?? defaultModeratFontFamilyMetadata
